// Copyright (c) 2025 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import {
  BatchGetTimesheetFieldConfigsRequest,
  GenerateTimesheetFieldConfigsRequest,
} from "../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

export const generateTimesheetFieldConfigs = createAction<GenerateTimesheetFieldConfigsRequest>("timesheet-fields/generate-timesheet-field-configs")
export const batchGetTimesheetFieldConfigs = createAction<BatchGetTimesheetFieldConfigsRequest>("timesheet-fields/batch-get-timesheet-field-configs")
